import EcoImg from 'eco-design/base/eco-img';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useScrollAnimation, cn } from 'elem/compPage/battery-backup-for-home/scroll-animation-v2';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

type SlideItem = {
    pc: string;
    h5: string;
    titleKey?: string;
    descKey?: string;
};

const SLIDE_IMAGES_MAP: Record<string, SlideItem[]> = {
    us: [
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767668898310-4wqdci-compressed-Frame%202094654851.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1768189729267-hd6a2c-compressed-Frame%202094654863.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767668915010-p05gbr-compressed-Frame%202094654852.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1768189741138-hge9iy-compressed-Frame%202094654864.jpg',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767668925165-q3mzay-compressed-Frame%202094654853.jpg',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1768189749507-qfpdl4-compressed-Frame%202094654865.jpg',
        },
    ],
    au: [
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231375321-m8sk22-compressed-Frame%2027.webp',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785231672141-xylrct-compressed-Frame%20128721138.webp',
            titleKey: 'secB_slide1_title',
            descKey: 'secB_slide1_desc',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231381542-m0i7fd-compressed-Frame%2032.webp',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785231676889-1mq9bk-compressed-Frame%20128721139.webp',
            titleKey: 'secB_slide2_title',
            descKey: 'secB_slide2_desc',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231387089-p4deif-compressed-Frame%2033.webp',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785231683634-cynkzs-compressed-Frame%20128721140.webp',
            titleKey: 'secB_slide3_title',
            descKey: 'secB_slide3_desc',
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231392930-bh2u7r-compressed-Frame%2034.webp',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785231688868-n3id7r-compressed-Frame%20128721141.webp',
            titleKey: 'secB_slide4_title',
            descKey: 'secB_slide4_desc',
        },
    ],
};

export default function MillionHomes() {
    const { t } = useLang('powerbackup');
    const { locale } = getLocal();
    const isAu = locale === 'au';
    const slideImages = SLIDE_IMAGES_MAP[locale] || SLIDE_IMAGES_MAP.us;

    const { ref, isVisible } = useScrollAnimation({
        threshold: 0.1,
    });

    return (
        <div className={`${styles.MillionHomes}${isAu ? ` ${styles.isAu}` : ''} GtmModuleData-section`}>
            <div ref={ref} className="header">
                <h2 className={cn(isVisible, 'power-backup-title fade-up')}>{t('secB_title')}</h2>
                <p className={cn(isVisible, 'power-backup-desc fade-up')} style={{ '--animate-delay': '0.15s' } as React.CSSProperties}>
                    {t('secB_desc')}
                </p>
                {isAu && (
                    <h2
                        className={cn(isVisible, 'power-backup-title fade-up power-backup-subtitle')}
                        style={{ '--animate-delay': '0.15s' } as React.CSSProperties}
                    >
                        {t('secB_subtitle')}
                    </h2>
                )}
            </div>

            <div className={`${cn(isVisible, 'swiper-container fade-up')} `} style={{ '--animate-delay': '0.3s' } as React.CSSProperties}>
                <Swiper
                    modules={[Navigation, Pagination]}
                    slidesPerView="auto"
                    centeredSlides={true}
                    spaceBetween={24}
                    loop={true}
                    navigation={{
                        prevEl: '.swiper-button-prev',
                        nextEl: '.swiper-button-next',
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        0: {
                            spaceBetween: 24,
                        },
                        768: {
                            spaceBetween: 48,
                        },
                        1024: {
                            spaceBetween: 12,
                        },
                    }}
                >
                    {slideImages.map((img, index) => (
                        <SwiperSlide key={index}>
                            <div className="slide-item">
                                <EcoImg pc={img.pc} pad={img.pc} h5={img.h5} />
                                {isAu && img.titleKey && (
                                    <div className="slide-caption">
                                        <p className="slide-title">{t(img.titleKey)}</p>
                                        {img.descKey && <p className="slide-desc">{t(img.descKey)}</p>}
                                    </div>
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </Swiper>
            </div>
        </div>
    );
}
